import { render, staticRenderFns } from "./gatorz-support.vue?vue&type=template&id=73a22d6c&scoped=true&"
import script from "./gatorz-support.vue?vue&type=script&lang=js&"
export * from "./gatorz-support.vue?vue&type=script&lang=js&"
import style0 from "./gatorz-support.vue?vue&type=style&index=0&id=73a22d6c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73a22d6c",
  null
  
)

export default component.exports